/**
 * Created by sadisha on 11/03/2025.
 */
(function () {
  'use strict';

  angular
    .module('crewSchedule')
    .controller('ignoreRegulationViolationsCtrl', crewScheduleNotificationCtrl);

  function crewScheduleNotificationCtrl(modalParams, $uibModalInstance, crewViolationsService, EventManagerService, MessageService) {
    const MAX_REMARKS_LENGTH = 1000;
    var vm = this;

    vm.model = {
      maxLength: MAX_REMARKS_LENGTH,

      ignoreRemarks: "",
      isIgnoreInputValid: true,
      isIgnoreInputLengthValid: true,

      restoreRemarks: "",
      isRestoreInputValid: true,
      isRestoreInputLengthValid: true
    };

    vm.onCloseClick = function (data) {
      $uibModalInstance.close(data);
    };

    vm.onIgnoreInputChange = function () {
      vm.model.isIgnoreInputValid = vm.model.ignoreRemarks && vm.model.ignoreRemarks.length > 0;
      vm.model.isIgnoreInputLengthValid = (vm.model.ignoreRemarks.length || 0) <= MAX_REMARKS_LENGTH;
    };

    vm.onRestoreInputChange = function () {
      vm.model.isRestoreInputValid = vm.model.restoreRemarks && vm.model.restoreRemarks.length > 0;
      vm.model.isRestoreInputLengthValid = (vm.model.restoreRemarks.length || 0) <= MAX_REMARKS_LENGTH;
    };

    vm.onIgnoreClick = function () {
      this.onIgnoreInputChange();

      if (vm.model.isIgnoreInputValid && vm.model.isIgnoreInputLengthValid) {
        EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, true);
        const context = this;

        const requestBody = {
          crewScheduleBlockIds: [modalParams.crewScheduleBlockId],
          remarks: vm.model.ignoreRemarks
        };

        crewViolationsService.ignoreViolations(requestBody,
          function(response){
            if(response.success) {
              EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, false);
              MessageService.success('Violations Ignored Successfully!');
              context.onCloseClick('IGNORED');
            } else {
              EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, false);
              MessageService.error(response.errors[0] || 'Something went wrong while ignoring violations.');
            }
          },
          function (error) {
            EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, false);
            MessageService.error(error || 'Something went wrong while ignoring violations.');
          }
        );
      }
    };

    vm.onRestoreClick = function () {
      this.onRestoreInputChange();

      if (vm.model.isRestoreInputValid && vm.model.isRestoreInputLengthValid) {
        EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, true);
        const context = this;

        const requestBody = {
          crewScheduleBlockIds: [modalParams.crewScheduleBlockId],
          remarks: vm.model.restoreRemarks
        };

        crewViolationsService.restoreViolations(requestBody,
            function(response){
              if(response.success) {
                EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, false);
                MessageService.success('Violations Restored Successfully!');
                context.onCloseClick('RESTORED');
              } else {
                EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, false);
                MessageService.error(response.errors[0] || 'Something went wrong while restoring violations.');
              }
            },
            function (error) {
              EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, false);
              MessageService.error(error || 'Something went wrong while restoring violations.');
            }
        );
      }
    };
  }
}());
